const modalGameRules = function($container = $('body')) {
  const $targets = $container.find('@modalGameRules');
  const $targetsPresent = $targets.length > 0;

  const showMsg = (props) => {
    const $msgTarget = props.$modal.find('@message');

    $container.on($.modal.OPEN, (event, modal) => {
      $msgTarget.html(props.$msg);
    });
    props.$modal.modal();
  };

  if ($targetsPresent) {
    $targets.each(function() {
      const $this = $(this);
      const $msg = $this.data('message');

      if ($msg !== '' && $msg !== undefined) {
        $this.addClass('info');
      }

      $this.on('click', (e) => {
        e.preventDefault();
        const $this = $(this);
        const $type = $this.data('type');

        const $modal = $container.find(`#game_rules_${$type}`);

        if ($msg !== '' && $msg !== undefined) {
          showMsg({ $msg, $type, $modal });
        }
      });
    });
  }
};

export default modalGameRules;
